import React  from 'react';
import './App.css';
import './Settings.css';
import SettingsLang from './SettingsLang.json';

class SettingsMain extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			userSettingsJsonObj: null,
			companySettingsJsonObj: null,
			geminiAPIKey: "",
			jsonModel: "",
			chatModel: "",
			docModel: "",
			showButtonsYN: false,
			googleModelListArray: null,
		}
	}
	
	async componentDidMount() {
		this.serverGetGoogleModelList();
		var userID = this.props.userID;
		var fullName = this.props.fullName;
		this.serverGetUserSettingsData(userID, fullName);
		var companyID = this.props.companyID;
		this.serverGetCompanySettingsData(companyID);
	}

	async serverGetGoogleModelList() {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/googleModelList.json";
		
		var googleModelListArray = null;
		
		try {
			var res = await fetch(url);
			googleModelListArray = await res.json();
		} catch (err) {
		}
		
		this.setState({
			googleModelListArray: googleModelListArray,
		});
	}

	async serverGetUserSettingsData(userID, userFullName) {

		if (userID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getusersettingsdata?userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var userSettingsJsonObj = null;
		
		try {
			var res = await fetch(url);
			userSettingsJsonObj = await res.json();
		} catch (err) {
		}

		if (userSettingsJsonObj === null) {
			return;
		}

		this.setState({
			userSettingsJsonObj: userSettingsJsonObj,
			geminiAPIKey: userSettingsJsonObj.geminiAPIKey,
			jsonModel: userSettingsJsonObj.jsonModel,
			chatModel: userSettingsJsonObj.chatModel,
			docModel: userSettingsJsonObj.docModel,
		});
	}

	async serverGetCompanySettingsData(companyID) {

		if (companyID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/getcompanysettingsdata?companyid=" + companyID;
		
		var companySettingsJsonObj = null;
		
		try {
			var res = await fetch(url);
			companySettingsJsonObj = await res.json();
		} catch (err) {
		}

		if (companySettingsJsonObj === null) {
			return;
		}

		this.setState({
			companySettingsJsonObj: companySettingsJsonObj,
		});
	}

	async serverSetUserSettings(userID, userFullName, geminiAPIKey, jsonModel, chatModel, docModel) {

		if (userID <= 0) {
			return null;
		}

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/setusersettings?userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		url = url + "&geminiapikey=" + encodeURIComponent(geminiAPIKey);
		url = url + "&jsonmodel=" + encodeURIComponent(jsonModel);
		url = url + "&chatmodel=" + encodeURIComponent(chatModel);
		url = url + "&docmodel=" + encodeURIComponent(docModel);
		
		try {
			var res = await fetch(url);
			await res.text();
		} catch (err) {
		}
	}

	onGeminiAPIKeyChanged(value) {
		this.setState({
			geminiAPIKey: value,
			showButtonsYN: true,
		});
	}
	
	onJsonModelChanged(value) {
		this.setState({
			jsonModel: value,
			showButtonsYN: true,
		});
	}
	
	onChatModelChanged(value) {
		this.setState({
			chatModel: value,
			showButtonsYN: true,
		});
	}
	
	onDocModelChanged(value) {
		this.setState({
			docModel: value,
			showButtonsYN: true,
		});
	}
	
	onKeyDown(keyCode) {
		var showButtonsYN = this.state.showButtonsYN;
		if (!showButtonsYN) {
			return;
		}
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	async onClickSaveButton() {
		
		var userSettingsJsonObj = this.state.userSettingsJsonObj;
		if (userSettingsJsonObj === null) {
			this.props.showToast("Error - cannot save");
			return;
		}
		
		var userID = this.props.userID;
		var fullName = this.props.fullName;
		var geminiAPIKey = this.state.geminiAPIKey;
		var jsonModel = this.state.jsonModel;
		var chatModel = this.state.chatModel;
		var docModel = this.state.docModel;

		await this.serverSetUserSettings(userID, fullName, geminiAPIKey, jsonModel, chatModel, docModel);

		var toastString = this.props.getLang(SettingsLang, "userSettingsSaved");
		this.props.showToast(toastString);
		
		this.setState({showButtonsYN: false});
	}
	
	onClickCancelButton() {

		var userID = this.props.userID;
		var fullName = this.props.fullName;
		this.serverGetUserSettingsData(userID, fullName);

		var toastString = this.props.getLang(SettingsLang, "userSettingsCancelled");
		this.props.showToast(toastString);
		
		this.setState({showButtonsYN: false});
	}

	renderModelOptions() {

		var googleModelListArray = this.state.googleModelListArray;
		if (googleModelListArray === null) {
			return null;
		}

		var i;
		var itemObj;
		var key;
		var modelID;
		var modelName;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<googleModelListArray.length; i++) {
			itemObj = googleModelListArray[i];
			modelID = itemObj.modelID;
			modelName = itemObj.modelName;
			key = "model-" + i;
			jsxCode = (<option key={key} value={modelID}>{modelID}</option>);
			jsxArray.push(jsxCode);
		}
		
		return jsxArray;
	}
	
	renderInputs() {
		
		var jsxArray = this.renderModelOptions();

		var companySettingsJsonObj = this.state.companySettingsJsonObj;
		var companyAPIKey = "";
		if (companySettingsJsonObj !== null) {
			companyAPIKey = companySettingsJsonObj.companyAPIKey;
		}
		
		return (
			<div>
				<fieldset className="SettingsMainFieldset">
					<legend className="SettingsMainLegend">{this.props.getLang(SettingsLang, "companyAPIKey")}</legend> 
					<input
						className="SettingsMainInput" 
						id="companyAPIKey" 
						type="text" 
						disabled={true}
						value={companyAPIKey}
					/>
				</fieldset>
				<div style={{height: "20px"}}></div>
				<fieldset className="SettingsMainFieldset">
					<legend className="SettingsMainLegend">{this.props.getLang(SettingsLang, "geminiAPIKey")}</legend> 
					<input
						className="SettingsMainInput" 
						autoFocus={true}
						id="geminiAPIKey" 
						type="text" 
						value={this.state.geminiAPIKey}
						onChange={(event) => this.onGeminiAPIKeyChanged(event.target.value)}
					/>
				</fieldset>
				<div style={{height: "20px"}}></div>
				<fieldset className="SettingsMainFieldset">
					<legend className="SettingsMainLegend">{this.props.getLang(SettingsLang, "jsonModel")}</legend> 
					<select 
						className="SettingsMainInput" 
						id="jsonModel" 
						value={this.state.jsonModel}
						onChange={(event) => this.onJsonModelChanged(event.target.value)}
					>
						{jsxArray}
					</select>
				</fieldset>
				<div style={{height: "20px"}}></div>
				<fieldset className="SettingsMainFieldset">
					<legend className="SettingsMainLegend">{this.props.getLang(SettingsLang, "chatModel")}</legend> 
					<select 
						className="SettingsMainInput" 
						id="chatModel" 
						value={this.state.chatModel}
						onChange={(event) => this.onChatModelChanged(event.target.value)}
					>
						{jsxArray}
					</select>
				</fieldset>
				<div style={{height: "20px"}}></div>
				<fieldset className="SettingsMainFieldset">
					<legend className="SettingsMainLegend">{this.props.getLang(SettingsLang, "docModel")}</legend> 
					<select 
						className="SettingsMainInput" 
						id="docModel" 
						value={this.state.docModel}
						onChange={(event) => this.onDocModelChanged(event.target.value)}
					>
						{jsxArray}
					</select>
				</fieldset>
			</div>
		);
	}
	
	renderButtons() {

		var showButtonsYN = this.state.showButtonsYN;
		if (!showButtonsYN) {
			return;
		}
		
		return (
			<div className="ViewContainerButtons2">
				<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(SettingsLang, "cancel")}</button>
				<div style={{width: "20px"}}></div>
				<button className="ViewSaveButton" onClick={() => this.onClickSaveButton()}>{this.props.getLang(SettingsLang, "save")}</button>
			</div>
		);
	}
	
	renderLinks() {
		return (
			<div>
				<a
					href="https://www.youtube.com/watch?v=RVGbLSVFtIk"
					target="_blank"
					rel="noopener noreferrer"
				>
					Get Your Gemini API Key in Google AI Studio
				</a>
				<div style={{height: "15px"}}></div>
				<a
					href="https://www.youtube.com/watch?v=fmEeDIpDdcI"
					target="_blank"
					rel="noopener noreferrer"
				>
					A Short Tutorial on Markdown for AI Prompts
				</a>
				<div style={{height: "15px"}}></div>
				<a
					href="https://chromewebstore.google.com/detail/webpage-to-markdown/ajeinonckioeekcfanjndliandidilid"
					target="_blank"
					rel="noopener noreferrer"
				>
					Chrome extension "Webpage to Markdown"
				</a>
			</div>
		);
	}

	render() {
		
		return (
			<div className="SettingsMainTopContainer">
				<div style={{height: "20px"}}></div>
				<div className="SettingsMainTopTitle">{this.props.getLang(SettingsLang, "settingsMainTopTitle")}</div>
				<div style={{height: "20px"}}></div>
				{this.renderInputs()}
				<div style={{height: "20px"}}></div>
				{this.renderButtons()}
				<div style={{height: "30px"}}></div>
				<hr/>
				<div style={{height: "30px"}}></div>
				{this.renderLinks()}
				<div style={{height: "20px"}}></div>					
			</div>
		);
	}
}

export default SettingsMain;

